module.exports = __webpack_public_path__ + "6a66edbab1aafa8f998b98b145f1a0fe.jpg";